var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIdentify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.625 75H159.375V131.25H140.625V75ZM140.625 168.75H159.375V225H140.625V168.75ZM168.75 140.625H225V159.375H168.75V140.625ZM75 140.625H131.25V159.375H75V140.625ZM37.5 93.75H18.75V37.5C18.75 32.5272 20.7254 27.7581 24.2417 24.2417C27.7581 20.7254 32.5272 18.75 37.5 18.75H93.75V37.5H37.5V93.75ZM93.75 281.25H37.5C32.5272 281.25 27.7581 279.275 24.2417 275.758C20.7254 272.242 18.75 267.473 18.75 262.5V206.25H37.5V262.5H93.75V281.25ZM262.5 281.25H206.25V262.5H262.5V206.25H281.25V262.5C281.25 267.473 279.275 272.242 275.758 275.758C272.242 279.275 267.473 281.25 262.5 281.25ZM281.25 93.75H262.5V37.5H206.25V18.75H262.5C267.473 18.75 272.242 20.7254 275.758 24.2417C279.275 27.7581 281.25 32.5272 281.25 37.5V93.75Z",
    fill: "#006D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIdentify);
export default __webpack_public_path__ + "static/media/map-identify.cf4d0cb69ccb0f1a87e8d2ffcc86655c.svg";
export { ForwardRef as ReactComponent };